import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Link, withRouter} from 'react-router-dom';
import queryString from 'query-string';
import Captcha from '../../../Common/Captcha';

import AddressSearchModal from '../../../Common/Address/AddressSeachModal';
import {fetchIdentificationWithRequestTokenOrRedirectOnFail} from '../../../../actions/identification.actions';
import {patchUserInfo} from '../../../../actions/user.actions';

import './userInfoModification.scss';
import {Button, ButtonGroup, PageContainer, PageSubTitle, PageTitle, Table} from '../../../Common/PageComponents';
import MessageBox from '../../../Common/MessageBox';

const stateToProps = state => {
  return {
    identification: state.identification,
    user: state.user,
  };
};

class UserInfoModification extends Component {
  componentDidMount() {
    let requestParams = queryString.parse(window.location.search);
    this.props.dispatch(
      fetchIdentificationWithRequestTokenOrRedirectOnFail(
        requestParams.identityToken,
        '/my-pc-bang/management/user-info-modification/identification',
        this.props.history,
        ''
      )
    );
  }

  _renderBusinessLicenseNumber(businessLicenseNumber) {
    if (!businessLicenseNumber) {
      return (
        <span className="null-business-license-number-warning">
          사업자 등록번호 미등록{' '}
          <span className="comment">
            ※ 등록/변경은 [고객센터 &gt; 1:1 문의]를 이용하여 사업자등록증 파일을 첨부해주세요
          </span>
        </span>
      );
    }

    return businessLicenseNumber;
  }

  _fillEmailDomain(e) {
    e.preventDefault();

    if (this.form.emailDomainSelectionBox.value) {
      this.form.emailDomain.disabled = true;
      this.form.emailDomain.value = this.form.emailDomainSelectionBox.value;
      return;
    }

    this.form.emailDomain.value = '';
    this.form.emailDomain.disabled = false;
    this.form.emailDomain.focus();
  }

  _preventNonNumericValue(e) {
    if (e.charCode < 48 || e.charCode > 57) {
      e.preventDefault();
    }
  }

  _prepareUserInfoModification(e) {
    e.preventDefault();
    if (this.form.newPassword.value && !this._validatePassword()) {
      this.form.newPassword.focus();
      return;
    }

    this.captchaRef.execute();
  }

  _modifyUserInfo(captchaToken) {
    if (captchaToken === undefined || captchaToken === '') {
      window.alert('Captcha token에 문제가 있습니다. 다시 진행해 주세요.');
      return;
    }

    const urlSearchParams = new URLSearchParams();
    if (this.form.zipno.value && this.form.roadNameAddress.value && this.form.landLotAddress.value) {
      urlSearchParams.append(
        'address',
        `(${this.form.zipno.value}) ${this.form.roadNameAddress.value} ${this.form.landLotAddress.value}`
      );
    }

    if (this.form.tel1.value && this.form.tel2.value && this.form.tel3.value) {
      urlSearchParams.append('telephone', `${this.form.tel1.value}-${this.form.tel2.value}-${this.form.tel3.value}`);
    }

    if (this.form.mobile1.value && this.form.mobile2.value && this.form.mobile3.value) {
      urlSearchParams.append(
        'mobile',
        `${this.form.mobile1.value}-${this.form.mobile2.value}-${this.form.mobile3.value}`
      );
    }

    if (this.form.emailId.value && this.form.emailDomain.value) {
      urlSearchParams.append('email', `${this.form.emailId.value}@${this.form.emailDomain.value}`);
    }

    urlSearchParams.append('agreeForSmsService', this.form.agreeForSmsService.checked);
    urlSearchParams.append('agreeForEmailService', this.form.agreeForEmailService.checked);

    if (this.form.newPassword.value) {
      urlSearchParams.append('newPassword', this.form.newPassword.value);
    }

    this.props.dispatch(patchUserInfo(urlSearchParams, captchaToken, this.props.history, this.captchaRef));
  }

  _validatePassword() {
    let password = this.form.newPassword.value;
    if (!password.match(/[A-Z]/g) || !password.match(/[a-z]/g)) {
      alert('비밀번호에 대문자와 소문자 조합을 포함하세요');
      return false;
    }
    if (!password.match(/[0-9]/g)) {
      alert('비밀번호에 숫자를 포함하세요.');
      return false;
    }
    if (password.length < 8 || password.length > 16) {
      alert('비밀번호는 8자리 이상 16자리 이하로 설정해주세요.');
      return false;
    }
    if (password.toLowerCase().includes(this.props.user.username)) {
      alert('사용자 아이디를 비밀번호에 포함할 수 없습니다.');
      return false;
    }
    if (this.form.newPassword.value !== this.form.newPasswordRetyped.value) {
      alert('새 비밀번호 확인란에 새 비밀번호와 동일한 비밀번호를 입력해주세요.');
      return false;
    }
    return true;
  }

  render() {
    if (Object.keys(this.props.identification).length === 0) {
      return null;
    }

    if (Object.keys(this.props.user).length === 0) {
      return null;
    }

    if (
      this.props.user.duplicationInformation &&
      this.props.user.duplicationInformation !== this.props.identification.discHash
    ) {
      alert('본인 인증한 정보와 계정 명의가 일치하지 않습니다.');
      return null;
    }

    let user = this.props.user;

    return (
      <PageContainer id="user-info-modification">
        <PageTitle title="가입정보수정" data-qa="usagePageTitle" />
        <PageSubTitle title={'기본 등록정보'} />
        <form ref={form => (this.form = form)} name="input_f" autoComplete="off" encType="multipart/form-data">
          <Table theme={'form'}>
            <colgroup>
              <col width={160} />
              <col width="*" />
              <col width={140} />
              <col width={260} />
            </colgroup>
            <tbody>
              <tr>
                <th>대표자 성명</th>
                <td colSpan={3}>{user.ownerName}</td>
              </tr>
              <tr>
                <th>아이디</th>
                <td colSpan={3}>{user.username}</td>
              </tr>
              <tr>
                <th>사업자 등록번호</th>
                <td colSpan={3}>{this._renderBusinessLicenseNumber(user.businessLicenseNumber)}</td>
              </tr>
              <tr>
                <th>PC방 주소</th>
                <td colSpan={3}>
                  <div className="current-value">{user.address}</div>
                  <input
                    type="text"
                    className="input_text"
                    id="zipno"
                    name="zipno"
                    maxLength={7}
                    style={{width: 92}}
                    readOnly
                    autoComplete="off"
                  />
                  &nbsp;
                  <AddressSearchModal
                    triggerButton={
                      <Button theme={'gray'} size={'small'}>
                        주소찾기
                      </Button>
                    }
                    roadNameInputCssSelector="#roadNameAddress"
                    zipCodeInputCssSelector="#zipno"
                  />
                  <div style={{margin: '5px 0'}}>
                    <input
                      type="text"
                      className="input_text"
                      style={{width: '432px'}}
                      id="roadNameAddress"
                      name="roadNameAddress"
                      readOnly="readonly"
                    />
                  </div>
                  <input
                    type="text"
                    className="input_text"
                    style={{width: '432px'}}
                    id="landLotAddress"
                    name="landLotAddress"
                    maxLength="70"
                  />
                </td>
              </tr>
              <tr>
                <th>PC방 전화번호</th>
                <td colSpan={3}>
                  <div className="current-value">{user.telephone}</div>
                  <select style={{width: 92}} name="tel1" defaultValue="">
                    <option value=""></option>
                    <option value="02">02</option>
                    <option value="031">031</option>
                    <option value="032">032</option>
                    <option value="033">033</option>
                    <option value="041">041</option>
                    <option value="042">042</option>
                    <option value="043">043</option>
                    <option value="051">051</option>
                    <option value="052">052</option>
                    <option value="053">053</option>
                    <option value="054">054</option>
                    <option value="055">055</option>
                    <option value="061">061</option>
                    <option value="062">062</option>
                    <option value="063">063</option>
                    <option value="064">064</option>
                    <option value="070">070</option>
                  </select>
                  &nbsp;
                  <input
                    type="text"
                    className="input_text"
                    maxLength={4}
                    name="tel2"
                    id="tel2"
                    onKeyPress={e => this._preventNonNumericValue(e)}
                    style={{width: 92}}
                    autoComplete="off"
                  />
                  &nbsp;
                  <input
                    type="text"
                    className="input_text"
                    maxLength={4}
                    name="tel3"
                    id="tel3"
                    onKeyPress={e => this._preventNonNumericValue(e)}
                    style={{width: 92}}
                    autoComplete="off"
                  />
                </td>
              </tr>
              <tr>
                <th>휴대전화</th>
                <td colSpan={3}>
                  <div className="current-value">{user.mobile}</div>
                  <select style={{width: 92}} name="mobile1" defaultValue="">
                    <option value=""></option>
                    <option value="010">010</option>
                    <option value="011">011</option>
                    <option value="016">016</option>
                    <option value="017">017</option>
                    <option value="018">018</option>
                    <option value="019">019</option>
                  </select>
                  &nbsp;
                  <input
                    type="text"
                    className="input_text"
                    maxLength={4}
                    name="mobile2"
                    id="mobile2"
                    onKeyPress={e => this._preventNonNumericValue(e)}
                    style={{width: 92}}
                    autoComplete="off"
                  />
                  &nbsp;
                  <input
                    type="text"
                    className="input_text"
                    maxLength={4}
                    name="mobile3"
                    id="mobile3"
                    onKeyPress={e => this._preventNonNumericValue(e)}
                    style={{width: 92}}
                    autoComplete="off"
                  />
                  <p style={{marginTop: 4}}>
                    <label>
                      <input type="checkbox" name="agreeForSmsService" defaultChecked={user.agreeForSmsService} /> SMS
                      수신 동의 (라이엇 게임즈의 게임/이벤트 정보의 수신 여부, 이벤트/광고 메일만 수신 거부 가능)
                    </label>
                  </p>
                </td>
              </tr>
              <tr>
                <th>이메일</th>
                <td colSpan={3}>
                  <div className="current-value">{user.email}</div>
                  <input
                    type="text"
                    className="input_text"
                    name="emailId"
                    style={{width: 154}}
                    maxLength={25}
                    id="emailId"
                    autoComplete="off"
                  />{' '}
                  @{' '}
                  <input
                    type="text"
                    className="input_text"
                    maxLength={25}
                    id="emailDomain"
                    name="emailDomain"
                    style={{width: 142}}
                    autoComplete="off"
                  />
                  &nbsp;
                  <select style={{width: 122}} name="emailDomainSelectionBox" onChange={e => this._fillEmailDomain(e)}>
                    <option value="">직접입력</option>
                    <option value="dreamwiz.com">dreamwiz.com</option>
                    <option value="empal.com">empal.com</option>
                    <option value="freechal.com">freechal.com</option>
                    <option value="gmail.com">gmail.com</option>
                    <option value="hanafos.com">hanafos.com</option>
                    <option value="hanmail.net">hanmail.net</option>
                    <option value="hitel.net">hitel.net</option>
                    <option value="hotmail.com">hotmail.com</option>
                    <option value="korea.com">korea.com</option>
                    <option value="lycos.co.kr">lycos.co.kr</option>
                    <option value="nate.com">nate.com</option>
                    <option value="naver.com">naver.com</option>
                    <option value="netican.com">netican.com</option>
                    <option value="paran.com">paran.com</option>
                    <option value="unitel.co.kr">unitel.co.kr</option>
                    <option value="yahoo.com">yahoo.com</option>
                  </select>
                  <p style={{marginTop: 4}}>
                    <label>
                      <input type="checkbox" name="agreeForEmailService" defaultChecked={user.agreeForEmailService} />{' '}
                      E-Mail 수신 동의 (라이엇 게임즈의 게임/이벤트 정보의 수신 여부, 이벤트/광고 메일만 수신 거부 가능)
                    </label>
                  </p>
                  <div style={{marginTop: 4}}>
                    <span>차후 ID/PW 찾기를 위해 이용되오니 꼭 유효한 이메일 주소를 기입해주시기 바랍니다.</span>
                  </div>
                </td>
              </tr>
            </tbody>
          </Table>
          <PageSubTitle title={'비밀번호 변경'} />
          <Table theme={'form'}>
            <colgroup>
              <col width={160} />
              <col width="*" />
            </colgroup>
            <tbody>
              <tr>
                <th>새 비밀번호</th>
                <td>
                  <input
                    type="password"
                    className="input_text"
                    maxLength={16}
                    id="newPassword"
                    name="newPassword"
                    autoComplete="off"
                  />
                </td>
              </tr>
              <tr>
                <th>새 비밀번호 확인</th>
                <td>
                  <input
                    type="password"
                    className="input_text"
                    maxLength={16}
                    id="newPasswordRetyped"
                    name="newPasswordRetyped"
                    autoComplete="off"
                  />
                </td>
              </tr>
            </tbody>
          </Table>
        </form>
        <MessageBox>
          <strong>비밀번호 변경 시 주의사항</strong>
          <ul>
            <li>8~16자의 영문 대문자+소문자+숫자가 꼭 하나씩 포함되어야 합니다. 예) Riotgames12</li>
            <li>아이디와 동일한 비밀번호 이용 불가</li>
            <li>현재 비밀번호를 신규 비밀번호로 이용 불가</li>
          </ul>
        </MessageBox>
        <ButtonGroup>
          <Captcha
            ref={captchaRef => (this.captchaRef = captchaRef)}
            onVerify={captchaToken => this._modifyUserInfo(captchaToken)}
          />
          <Button onClick={e => this._prepareUserInfoModification(e)}>변경사항 저장</Button>
          <Link to="/">
            <Button theme={'gray'}>취소</Button>
          </Link>
        </ButtonGroup>
      </PageContainer>
    );
  }
}

export default withRouter(connect(stateToProps)(UserInfoModification));
